(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/hooks/use-is-mounted.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/hooks/use-is-mounted.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useCallback = _React.useCallback;
const useIsMounted = () => {
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  return useCallback(() => mountedRef.current, []);
};
setGlobal('svs.ticketsOrderHome.hooks.useIsMounted', useIsMounted);

 })(window);